

import React, { Component } from 'react';
import './Style.css';
import '../../../custom.css'
import { Alert } from '../../Utils/Alert';
import { Loading } from '../../Utils/Loading';

export class SeniorityForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isPost: false,
            loading: false,
            dataProfile: {
                id: !isNaN(window.location.href.substring(window.location.href.lastIndexOf('/') + 1)) ? window.location.href.substring(window.location.href.lastIndexOf('/') + 1) : 0
            },
            alert: {
                Title: '',
                Body: '',
                Type: '',
                Show: false
            }
        }
    }

    selectedImage(e, source) {
        if (e.currentTarget.files.length > 0) {
            this.getBase64(e.currentTarget.files[0], source)
        }
    }

    getBase64(file, source) {
        var context = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {

            if (source == 'logo') {
                var model = context.state.dataProfile;
                model.newLogo = reader.result;
                model.logo = reader.result;
                context.setState({ dataProfile: model, enableButton: true });
            }

            if (source == 'photoTeam') {
                var model = context.state.dataProfile;
                model.newPhotoTeam = reader.result;
                model.photoTeam = reader.result;
                context.setState({ dataProfile: model, enableButtonTeam: true });
            }

            if (source == 'photoSeniors') {
                var model = context.state.dataProfile;
                model.newPhotoTeamSeniority = reader.result;
                model.photoTeamSeniority = reader.result;
                context.setState({ dataProfile: model, enableButton: true });
            }
        };
        reader.onerror = function (error) {
            alert("Error subiendo imagen, por favor inténtelo de nuevo.")
        };
    }

    componentDidMount() {
        if (this.state.dataProfile.id > 0) {
            this.GetSeniorityById();
        }
    }

    componentDidUpdate() {
        if (document.querySelector(".drop_box")) {

            var elementos = document.querySelectorAll(".drop_box");
            elementos.forEach((a, i) => {

                var buttonFile = a.querySelector("button");
                var input = a.querySelector("input");

                buttonFile.onclick = () => {
                    input.click();
                };

            })
        }
    }

    async GetSeniorityById() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` }
        }

        this.setState({ loading: true });

        const response = await fetch(`Profile/GetSeniorityById?id=${this.state.dataProfile.id}`, request);

        this.setState({ loading: false });

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ dataProfile: data });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No se puedo obtener el seniority para editar',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async SeniorityForm() {
        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            body: JSON.stringify(this.state.dataProfile)
        }

        this.setState({ loading: true });

        const response = await fetch(`Profile/SeniorityForm`, request);

        this.setState({ loading: false });

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            this.setState({
                alert: {
                    Title: 'Éxito',
                    Body: 'seniorato guardado correctamente',
                    Type: 'alert-success',
                    Show: true
                }
            });
            window.location.href = '/comunidad/mi-perfil';
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'guardando el seniorato',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async Delete() {
        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` }
        }

        this.setState({ loading: true });

        const response = await fetch(`Profile/Delete?id=${this.state.dataProfile.id}`, request);

        this.setState({ loading: false });

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            this.setState({
                alert: {
                    Title: 'Éxito',
                    Body: 'seniorato eliminado correctamente',
                    Type: 'alert-success',
                    Show: true
                }
            });
            window.location.href = '/comunidad/mi-perfil';
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'eliminando el plan',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    render() {

        return (
            <div className="col-lg-12 row mt-5">

                <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/comunidad">Inicio</a></li>
                            <li class="breadcrumb-item"><a href="/comunidad/mi-perfil">Mi perfil</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Seniority</li>
                        </ol>
                </nav>
                

                <div className="col-lg-12 form-group">
                    <label>Nombre del PL</label>
                    <input type="text" className="form-control" maxLength="255" value={this.state.dataProfile.title} onChange={(e) => {
                        var model = this.state.dataProfile;
                        model.title = e.currentTarget.value;
                        this.setState({ dataProfile: model });

                    }}></input>
                </div>

                <div className="col-lg-12 form-group">
                    <label>Nombre del buddy</label>
                    <input type="text" className="form-control" maxLength="255" value={this.state.dataProfile.buddyName} onChange={(e) => {
                        var model = this.state.dataProfile;
                        model.buddyName = e.currentTarget.value;
                        this.setState({ dataProfile: model });

                    }}></input>
                </div>

                <div className="col-lg-12 form-group">
                    <label>Contrato del buddy</label>
                    <input type="text" className="form-control" maxLength="255" value={this.state.dataProfile.contractBuddy} onChange={(e) => {
                        var model = this.state.dataProfile;
                        model.contractBuddy = e.currentTarget.value;
                        this.setState({ dataProfile: model });

                    }}></input>
                </div>

                <div className="col-lg-12 form-group">
                    <label>Visión del equipo</label>
                    <textarea className="form-control" maxLength="4000" value={this.state.dataProfile.vision} onChange={(e) => {
                        var model = this.state.dataProfile;
                        model.vision = e.currentTarget.value;
                        this.setState({ dataProfile: model });

                    }}></textarea>
                </div>

                <div className="form-group row col-lg-12">
                    <div class="card col-lg-4 text-center">
                        {
                            !this.state.dataProfile.logo ?
                                <div class="drop_box">
                                    <header>
                                        <h4>Insignia del equipo</h4>
                                    </header>
                                    <p>Archivos soportados: .jpg, .jpeg, .png, .gif</p>
                                    <input type="file" hidden accept="image/*" id="fileID" style={{ "display": "none" }} onChange={(e) => { this.selectedImage(e, 'logo') }} />
                                    <button class="btn">Seleccionar foto</button>
                                </div>
                                :
                                <div class="image-is-selected" >
                                    <div className="wrapp-photo">
                                        <img src={this.state.dataProfile.logo} />
                                    </div>
                                    <input type="button" className="btn btn-danger" value="Eliminar" onClick={(e) => {
                                        var model = this.state.dataProfile;
                                        model.logo = '';
                                        model.newLogo = '';
                                        this.setState({ dataProfile: model })
                                    }} />
                                </div>
                        }


                    </div>
                    <div class="card col-lg-4 text-center">
                        {
                            !this.state.dataProfile.photoTeam ?
                                <div class="drop_box">
                                    <header>
                                        <h4>Foto del equipo</h4>
                                    </header>
                                    <p>Archivos soportados: .jpg, .jpeg, .png, .gif</p>
                                    <input type="file" hidden accept="image/*" id="fileID" style={{ "display": "none" }} onChange={(e) => { this.selectedImage(e, 'photoTeam') }} />
                                    <button class="btn">Seleccionar foto</button>
                                </div>
                                :
                                <div class="image-is-selected" >
                                    <div className="wrapp-photo">
                                        <img src={this.state.dataProfile.photoTeam} />
                                    </div>
                                    <input type="button" className="btn btn-danger" value="Eliminar" onClick={(e) => {
                                        var model = this.state.dataProfile;
                                        model.photoTeam = '';
                                        model.newPhotoTeam = '';
                                        this.setState({ dataProfile: model })
                                    }} />
                                </div>
                        }


                    </div>
                    <div class="card col-lg-4 text-center">
                        {
                            !this.state.dataProfile.photoTeamSeniority ?
                                <div class="drop_box">
                                    <header>
                                        <h4>Foto de los seniors</h4>
                                    </header>
                                    <p>Archivos soportados: .jpg, .jpeg, .png, .gif</p>
                                    <input type="file" hidden accept="image/*" id="fileID" style={{ "display": "none" }} onChange={(e) => { this.selectedImage(e, 'photoSeniors') }} />
                                    <button class="btn">Seleccionar foto</button>
                                </div>
                                :
                                <div class="image-is-selected" >
                                    <div className="wrapp-photo">
                                        <img src={this.state.dataProfile.photoTeamSeniority} />
                                    </div>
                                    <input type="button" className="btn btn-danger" value="Eliminar" onClick={(e) => {
                                        var model = this.state.dataProfile;
                                        model.photoTeamSeniority = '';
                                        model.newPhotoTeamSeniority = '';
                                        this.setState({ dataProfile: model })
                                    }} />
                                </div>
                        }


                    </div>
                </div>

                <div className="col-lg-12 form-group">

                    <a href="/comunidad/mi-perfil" className="btn btn-cancel mr-2">Volver</a>

                    <input type="button" className="btn btn-primary" value="Guardar" disabled={!this.state.dataProfile.title} onClick={() => {
                        this.SeniorityForm();
                    }}></input>

                    
                </div>

                {
                    this.state.dataProfile.id > 0 ?
                        <div>
                            <div className="col-lg-12 form-group">
                                <label for="checkDelete">
                                    <input type="checkbox" id="checkDelete" onClick={(e) => {
                                        this.setState({ canDelete: e.currentTarget.checked });
                                    }}></input>
                            Marca esta casilla si deseas eliminar este seniorato de tu lista.
                        </label>
                            </div>
                            <div className="col-lg-12 form-group">
                                <input type="button" className="btn btn-danger" value="Eliminar" disabled={!this.state.canDelete} onClick={() => {
                                    this.Delete()
                                }}></input>
                            </div> 
                        </div> : null
                            }

                {this.state.alert.Show ? <Alert Title={this.state.alert.Title} Type={this.state.alert.Type} Body={this.state.alert.Body} callBack={() => { this.setState({ alert: { show: false } }) }} /> : null}
                {this.state.loading ? <Loading /> : null}
            </div>
        );
    }
}

